// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1O7OX","errorLogs":"styles_errorLogs__QFp_o"};